import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';

@Injectable()
export class PalletsDefaultUnitBagCemFeature implements IFlagFeature {
  name = Features.PALLETS_DEFAULT_UNIT_BAG_CEM;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
